// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1APEy","emails":"CreateEditClinics_emails__15e4r","emailTagLabel":"CreateEditClinics_emailTagLabel__1XFBE"};